import React from 'react';
import PropTypes from 'prop-types';

import CemeteryLogo from '../cemetery-logo/cemetery-logo';

import { LogoLocation } from '../../constants';

import './module-header.scss';

const ModuleHeader = ({ text, title, error }) => (
  <div className="module-header">
    <div className="module-header__wrapper">
      <h1 className="module-header__title">{title}</h1>
      <CemeteryLogo location={LogoLocation.HEADER} />
    </div>
    <p
      className={`module-header__text ${
        error ? 'module-header__text_error' : ''
      }`}
    >
      {text}
    </p>
  </div>
);

ModuleHeader.defaultProps = {
  error: false,
  text: '',
  title: '',
};

ModuleHeader.propTypes = {
  error: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
};

export default ModuleHeader;
